import React, { createContext, FC, ReactNode, useContext } from 'react';

type ComponentsKeyValue = { key: string; component: React.ComponentType<any> };

export const CustomComponentsContext = createContext<ComponentsKeyValue[]>([]);

export const CustomComponentsProvider: FC<{
  children: ReactNode;
  list: ComponentsKeyValue[];
}> = ({ children, list }) => (
  <CustomComponentsContext.Provider value={list}>
    {children}
  </CustomComponentsContext.Provider>
);

export const useCustomComponents = () => useContext(CustomComponentsContext);
